<template>
  <div class="page-add">
    <div class="add-title">{{ !editId ? "新增班级" : "编辑班级" }}</div>
    <el-form class="form" size="small" label-position="right" label-width="130px" :rules="rules" :model="classForm"
      ref="classForm">
      <el-row>
        <el-col :span="3">
          <el-form-item label="班级名称：" prop="classYear">
            <el-date-picker class="year_style" align="center" v-model="classForm.classYear" type="year"
              value-format="yyyy" format="yyyy" placeholder="选择年份" :disabled="!!editId" @change="yearChange">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label-width="60px" prop="className" :rules="[
            rulesFactory.required('请输入班级名称'),
            rulesFactory.size('最多输入100个字', 0, 100),
          ]">
            <el-input v-model="classForm.className" placeholder="请输入班级名称" class="class-name">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主办单位：" prop="organizerIds">
            <!-- <el-input v-model="classForm.organizerIds" placeholder="请输入主办单位"></el-input> -->
            <el-select v-model="classForm.organizerIds" placeholder="请选择主办单位" multiple class="select"
              style="width: 64%">
              <el-option v-for="(item, i) in classDropList" :key="i" :label="item.organizerName"
                :value="item.uuid"></el-option>
            </el-select>
            <el-button style="margin-left: 15px;" @click="toAddOrganizer">去新增</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级类型：" prop="trainType">
            <el-cascader v-model="classForm.trainType" :options="treeCdata" :props="props" placeholder="请选择班级类型"
              style="width: 100%">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办班级别：" prop="classLevel" required>
            <el-select class="form-select" v-model="classForm.classLevel" placeholder="请选择办班级别">
              <el-option v-for="item in classLevelData" :key="item.paramKey" :label="item.paramValue"
                :value="Number(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="报名方式：" prop="enrollMode" :rules="[rulesFactory.required('请选择报名方式')]">
            <el-radio-group v-model="classForm.enrollMode">
              <el-radio :label="1">联络员报名</el-radio>
              <el-radio :label="0">自主报名</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="报名部门：" prop="enrollDeptNames" :rules="[rulesFactory.required('请选择报名部门')]">
            <el-input class="form-dept" v-model="classForm.enrollDeptNames" placeholder="请选择可报名部门"></el-input>
            <el-button class="button-dept" @click="selectDep">选择</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="scale" label="报名条件：" prop="" v-if="classForm.enrollMode != 1">
            <WYSelect v-model="classForm.cadreLevelList"  placeholder="请选择报名条件"
              :options="cadreTypeAttr" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="报名时间：" prop="enrollTime" :rules="[
          {
            required: true,
            validator: checkEnrollTime,
            trigger: 'blur',
          },
        ]">
            <el-date-picker unlink-panels v-model="classForm.enrollTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd" @change="enrollTimeChange">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="培训时间：" prop="trainTime" :rules="[
          {
            required: true,
            validator: checkTrainTime,
            trigger: 'blur',
          },
        ]">
            <el-date-picker unlink-panels v-model="classForm.trainTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd" @change="trainTimeChange">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="班级简介：" prop="desc" :rules="[
            rulesFactory.required('请输入班级简介'),
            rulesFactory.size('最多输入200个字', 0, 200),
          ]">
            <el-input type="textarea" rows="4" v-model="classForm.desc" placeholder="请输入班级简介"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <div style="width: 95%">
          <el-col :span="8">
            <el-form-item label="配图：" prop="webCover" :rules="[rulesFactory.required('请选择WEB封面')]">
              <div v-if="classForm.webCover" id="video-output" @mouseenter="showCover1 = true"
                @mouseleave="showCover1 = false">
                <img :src="classForm.webCover" class="avatar" />
                <div v-show="showCover1" class="cover-bg">
                  <i class="el-icon-zoom-in delete" @click.stop="showViewer1 = true"></i>
                  <i class="el-icon-delete delete" @click.stop="deleteCover(1)"></i>
                </div>
              </div>
              <el-upload v-else action="" class="avatar-uploader" :show-file-list="false" :http-request="uploadCover1"
                accept="png,jpg,jpeg" :limit="1" ref="coverUpload1">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!classForm.webCover" class="upload-text">上传图片</label>
              </el-upload>
              <div class="upload_tip">
                <p>WEB封面</p>
                <p class="img_tip">建议尺寸：1200px*600px（或2:1）</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="scale" prop="appCover" :rules="[rulesFactory.required('请选择APP封面')]">
              <div v-if="classForm.appCover" id="video-output" @mouseenter="showCover2 = true"
                @mouseleave="showCover2 = false">
                <img :src="classForm.appCover" class="avatar" />
                <div v-show="showCover2" class="cover-bg">
                  <i class="el-icon-zoom-in delete" @click.stop="showViewer2 = true"></i>
                  <i class="el-icon-delete delete" @click.stop="deleteCover(2)"></i>
                </div>
              </div>
              <el-upload v-else action="" class="avatar-uploader" :show-file-list="false" :http-request="uploadCover2"
                accept="png,jpg,jpeg" :limit="1" ref="coverUpload2">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!classForm.appCover" class="upload-text">上传图片</label>
              </el-upload>
              <div class="upload_tip">
                <p>APP封面</p>
                <p class="img_tip">建议尺寸：1125px*468px（或12:5）</p>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="承办单位：" :rules="[rulesFactory.required('请选择APP封面')]">
            <take-unit @getTakeUnit="getTakeUnit" :initUnits="classForm.undertakeUnitList" v-if="loadFlag" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="classForm.enrollMode == 1 ? '计划人数：' : '限制名额：'" prop="planStuNum" :rules="[rulesFactory.required('请选择限制名额')]">
            <el-input-number class="input" v-model="classForm.planStuNum" :min="1" :step="10"
              label="描述文字"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item class="scale" label="结业要求：" prop="graduationRequirements">
            <el-input type="textarea" placeholder="请输入结业要求" v-model="classForm.graduationRequirements" rows="5"
              maxlength="200" show-word-limit>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级管理员：" prop="auditUserIds" :rules="[rulesFactory.required('请选择班级管理员')]">
            <el-select v-model="classForm.auditUserIds" class="select" multiple placeholder="请选择班级管理员"
              style="width: 64%" filterable>
              <el-option v-for="item in auditUserList" :key="item.uuid" :label="item.userName"
                :value="String(item.uuid)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <el-button @click="resetForm" v-show="!editId">重置</el-button>
            <back-button :floatLeft="false" :pathOptions="{ path: '/onlineClass' }" />
            <el-button type="primary" @click.stop="submitClassInfo">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 图片预览 -->
    <el-image-viewer v-if="showViewer1" :on-close="() => {
      showViewer1 = false;
    }
      " :url-list="[classForm.webCover]" />
    <el-image-viewer v-if="showViewer2" :on-close="() => {
      showViewer2 = false;
    }
      " :url-list="[classForm.appCover]" />
    <dept :enrollDeptVos="checkedEnrollDeptVos" @enrollDeptSelected="enrollDeptSelected"></dept>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { Confirm } from "@/components/Confirm";
import {
  saveStudyClass,
  getEnrollAuditorList,
  getStudyClassInfo,
  updateStudyClass,
  getClassDropList
} from "@/api/class";
import { getTopDepts } from "@/api/dept";
import { treeChildVos } from "@/api/classOffline";
import { getSysParamByTypes, getBusinessParamByTypes } from "@/api/sysParam";
import FileHandler from "@/utils/file";
import WYSelect from "@/components/wySelect";
import vue from "../../../main";
import moment from "moment";
import Dept from "./deptNew";
import rulesFactory from "@/utils/rules";
import TakeUnit from "@/views/offlineClass/add/takeUnit";
import { setItem } from "@/utils/storage.js";
import { getDaysBetween } from "@/utils/timeFormat";
import BackButton from "@/components/backButton/index";
import { getItem } from "@/utils/storage.js"

export default {
  name: "classAdd",
  components: { ElImageViewer, Dept, TakeUnit, BackButton, WYSelect },
  data() {
    return {
      props: {
        //树形
        value: "key",
        label: "name",
        children: "children",
        // checkStrictly: true,
      },
      treeCdata: [],
      loadFlag: false,
      editId: null,
      rulesFactory,
      defaultCheckedKeys: [],
      checkedEnrollDeptVos: [],
      trainTypeData: [],
      classLevelData: [],
      publicData: [],
      auditUserList: [],
      currentPeriod: 0,
      classForm: {
        classYear: "",
        trainType: ["2", "24"],
        classLevel: 0,
        enrollMode: 1,
        enrollDeptNames: "",
        undertakeUnitList: [],
        enrollDeptIds: [],
        graduationRequirements: '',
        auditUserIds: [],
        organizerIds: [],
        planStuNum: 1,
        webCover: "",
        appCover: "",
        cadreLevelList: [],
      },
      showCover1: false,
      showCover2: false,
      showViewer1: false,
      showViewer2: false,
      rules: {
        className: [
          rulesFactory.required("请输入班级名称"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        organizerIds: [
          rulesFactory.required("请选择主办单位")
        ],
        trainType: [rulesFactory.required("请选择班级类型")],
        classLevel: [rulesFactory.required("请选择办班级别")],
        graduationRequirements: [
          rulesFactory.required("请输入结业要求"),
          rulesFactory.size("最多输入200个字", 0, 200),
        ]
      },
      classStatus: null,
      topDeptList: [],
      classDropList: [],
      cadreTypeAttr: [],
      isShowDept: false,
      defaultRemark: '1、完成专题班全部课件方可成功结业，结业后可获得集中培训学时。\n2、温馨提醒：专题班课件学习进度与网络自学课件学习进度相互独立，报名专题班后需重新学习所有课件。'
    };
  },
  created() {
    this.editId = this.$route.query.id;
    this.classStatus = this.$route.query.status;
    this.deptLevelCode = getItem("deptLevelCode");
    // 线上班级新增时，根据用户 deptLevelCode 去请求班级管理员列表
    this.getTypeList(this.deptLevelCode);
    this.getClassDropList();
    if (this.editId) {
      getStudyClassInfo(this.editId).then((res) => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        // 编辑的情况 拿到回传的 deptLevelCodes 去请求班级管理员列表。进行回显班级管理员字段
        this.getCanAudit(obj.enrollDeptVos.map(ele => ele.deptLevelCode), false);
        let auditUserIds = obj.auditUserIds;
        if (auditUserIds) {
          for (let i = 0; i < auditUserIds.length; i++) {
            auditUserIds[i] = String(auditUserIds[i]);
          }
        }

        // 格式化时间
        obj.trainTime = [moment(obj.trainStartTime), moment(obj.trainEndTime)];
        obj.enrollTime = [
          moment(obj.enrollStartTime),
          moment(obj.enrollEndTime),
        ];
        this.classForm = obj;
        // this.classForm.auditUserIds = auditUserIds;
        this.loadFlag = true;
        // this.defaultCheckedKeys = this.classForm.enrollDeptVos.map((ele) => ele.deptId);
        this.classForm.enrollDeptIds = this.classForm.enrollDeptVos.map((ele) => ele.deptId);
        this.checkedEnrollDeptVos = this.classForm.enrollDeptVos;
        treeChildVos({ type: "CLASS_TYPE_UP" }).then((res) => {
          if (!res || res.code != 0) return;
          let tg = this.classForm.trainType;
          let tt = [0, String(tg)];
          this.treeCdata = res.data || [];
          this.treeCdata.forEach((x) => {
            if (x.children) {
              x.children.forEach((y) => {
                if (y.key == tt[1]) {
                  tt[0] = x.key;
                }
              });
            }
          });
          this.classForm.trainType = tt;
        });
      });
      this.rules.className = [];
    } else {
      this.loadFlag = true;
      // this.addTrainInfoDto();
      let date = new Date();
      this.classForm.classYear = date.getFullYear().toString();
      this.classForm.graduationRequirements = this.defaultRemark;
      treeChildVos({ type: "CLASS_TYPE_UP" }).then((res) => {
        if (!res || res.code != 0) return;
        this.treeCdata = res.data;
      });
    }
    this.getSysParamByTypes([
      "CLASS_LEVEL_TYPE",
      "CLASS_TYPE_UP",
    ]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.classLevelData = res.data["CLASS_LEVEL_TYPE"];
        this.trainTypeData = res.data["CLASS_TYPE_UP"];
        if (!this.edit) {
          // 设置默认选中
          if (this.classLevelData.length > 0) {
            this.classForm.classLevel = Number(this.classLevelData[0].paramKey);
          }

        }
      });
    },
    getTypeList(deptLevelCode) {
      let types = ['CLASS_CADRE_LEVEL'];
      getBusinessParamByTypes({ types, deptLevelCode }).then((res) => {
        if (!res || res.code != 0) return;
        this.cadreTypeAttr = res.data["CLASS_CADRE_LEVEL"]
      });
    },
    // 获取主办单位-列表
    getClassDropList() {
      let params = {
        type: 1 // type=1:线上线下，type=2：中组部
      };
      getClassDropList(params).then((res) => {
        if (!res || res.code != 0) return;
        this.classDropList = res.data;
      })
    },
    getTakeUnit(val) {
      this.classForm.undertakeUnitList = val;
    },
    // 查询部门树顶节点-zhaogang
    getTopDepts(nodeArr) {
      getTopDepts(nodeArr).then((res) => {
        if (!res || res.code != 0) return;
        this.topDeptList = res.data || [];
        
        this.getCanAudit(this.topDeptList.map(ele => ele.deptLevelCode), true)
      });
    },
    getCanAudit(levelCodes, flag) {
      getEnrollAuditorList(levelCodes).then((res) => {
        if (!res || res.code != 0) return;
        this.auditUserList = res.data || [];
        if (flag) {
          this.classForm.auditUserIds = [];
        }
      });
    },
    enrollDeptSelected(dept) {
      this.classForm.enrollDeptIds = dept.ids;
      this.$set(this.classForm, "enrollDeptVos", dept.enrollDeptVos);
      this.checkedEnrollDeptVos = this.classForm.enrollDeptVos;
      this.$set(this.classForm, "enrollDeptNames", dept.names.join(","));
      this.getTopDepts(dept.enrollDeptVos);
    },

    // 校验报名时间
    checkEnrollTime(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请选择报名时间"));
      } else if (this.classForm.trainTime && this.classForm.trainTime.length > 1 && moment(value[1]) >= moment(this.classForm.trainTime[0])) {
        callback(new Error("报名结束时间应早于培训开始时间"));
      } else {
        callback();
      }
    },

    checkTrainTime(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请选择培训时间"));
      } else if (this.classForm.classYear) {
        const yearStart = moment(`${this.classForm.classYear}-01-01`, 'YYYY-MM-DD 00:00:00');
        const yearEnd = moment(`${parseInt(this.classForm.classYear) + 1}-01-01`, 'YYYY-MM-DD 00:00:00');
        if (moment(value[0]).isBefore(yearStart) || moment(value[0]).isSameOrAfter(yearEnd)) {
          callback(new Error("培训开始时间必须在班级年度范围内"));
        } else if (this.classForm.enrollTime && this.classForm.enrollTime.length > 1 && moment(value[0]).isSameOrBefore(moment(this.classForm.enrollTime[1]))) {
          callback(new Error("培训开始时间必须晚于报名结束时间"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 当培训时间变化时，触发培训时间的校验
    trainTimeChange() {
      // 当培训时间变化时，且报名时间有值时，触发报名时间的校验
      if (this.$refs.classForm && 
          this.classForm.enrollTime && 
          this.classForm.enrollTime.length > 0) {
        this.$refs.classForm.validateField('enrollTime');
      }
    },
    
    // 当报名时间变化时，且培训时间有值时，触发培训时间的校验
    enrollTimeChange() {
      // 当报名时间变化时，且培训时间有值时，触发培训时间的校验
      if (this.$refs.classForm && 
          this.classForm.trainTime && 
          this.classForm.trainTime.length > 0) {
        this.$refs.classForm.validateField('trainTime');
      }
    },
    // 当年份变化时，触发培训时间的校验
    yearChange(val) {
      // 当班级年份变化时，且培训时间有值时，触发培训时间的校验
      if (this.$refs.classForm && 
          this.classForm.trainTime && 
          this.classForm.trainTime.length > 0) {
        this.$refs.classForm.validateField('trainTime');
      }
    },
    selectDep() {
      vue.$emit("selectDep");
    },
    // 初始化当前期次数据
    addTrainInfoDto() {
      this.classForm = {
        desc: "",
        enrollDeptNames: "",
        enrollDeptIds: [],
        auditUserName: "",
        auditUserIds: [],
        periodNum: 1,
        planStuNum: 1,
        undertakeUnit: "",
        undertakeUnitList: [],

        enrollStartTime: "",
        enrollEndTime: "",
        trainStartTime: "",
        trainEndTime: "",
        classLevel: 0,
        trainType: 0,
        classYear: "",
        organizerIds: [],
      };
    },
    // 重置表单数据
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        let className = this.classForm.className;
        this.$refs["classForm"].resetFields();
        let date = new Date();
        this.classForm = {
          className,
          classYear: date.getFullYear().toString(),
          enrollDeptNames: "",
          enrollDeptIds: [],
          auditUserName: "",
          auditUserIds: [],
          periodNum: 1,
          planStuNum: 1,
          undertakeUnit: "",
          undertakeUnitList: [],
          webCover: "",
          appCover: "",
          trainStartTime: "",
          trainEndTime: "",
          classLevel: 0,
          trainType: ["2", "24"],
          graduationRequirements: this.defaultRemark,
        };
        if (this.classLevelData.length > 0) {
          this.classForm.classLevel = Number(this.classLevelData[0].paramKey);
        }
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 删除封面
    deleteCover(index) {
      switch (index) {
        case 1: {
          this.classForm.webCover = "";
          break;
        }
        case 2: {
          this.classForm.appCover = "";
          break;
        }
      }
    },
    // 上传WEB封面
    async uploadCover1(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload1"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.classForm.webCover = url;
      });
    },
    // 上传封面
    async uploadCover2(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload2"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.classForm.appCover = url;
      });
    },
    //新增视频
    submitClassInfo() {
      this.$refs["classForm"]
        .validate()
        .then(() => {
          let params = Object.assign({}, this.classForm);
          params.trainType =
            params.trainType[params.trainType.length - 1] || "";
          let rawData = this.classForm;

          params["trainStartTime"] = moment(rawData.trainTime[0]).format(
            "YYYY-MM-DD 00:00:00"
          );
          params["trainEndTime"] = moment(rawData.trainTime[1]).format(
            "YYYY-MM-DD 23:59:59"
          );
          params["enrollStartTime"] = moment(rawData.enrollTime[0]).format(
            "YYYY-MM-DD 00:00:00"
          );
          params["enrollEndTime"] = moment(rawData.enrollTime[1]).format(
            "YYYY-MM-DD 23:59:59"
          );
          params["periodNum"] = 1;
          if (this.topDeptList && this.topDeptList.length > 0) {
            params["enrollDeptVos"] = JSON.parse(JSON.stringify(this.topDeptList));
            params["enrollDeptIds"] = this.topDeptList.map(ele => ele.deptId);
          }

          if (!this.editId) {
            saveStudyClass(params).then((res) => {
              if (!res || res.code != 0) return;
              setItem(this.REFRESH_FLAG, true);
              this.$message({
                message: "班级新增成功！",
                type: "success",
              });
              this.$router.push({ path: '/onlineClass' });
            });
          } else {
            updateStudyClass(params).then((res) => {
              if (!res || res.code != 0) return;
              setItem(this.REFRESH_FLAG, true);
              this.$message({
                message: "班级修改成功！",
                type: "success",
              });
              this.$router.push({ path: '/onlineClass' });
            });
          }
        })
        .catch(() => { });
    },
    toAddOrganizer() {
      this.$router.push({
        path: "/sponsorManage",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;

/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}

/deep/ .scale .el-input {
  // width: 50%;
  color: $textColor;
  font-size: 12px;
}

.form-select {
  width: 100%;
}

/deep/ .el-form-item__content {
  .form-dept {
    width: calc(50% - 139px);
    font-size: inherit;
  }

  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }

  .el-select.select {
    width: calc(100% - 90px) !important;
  }
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 280px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 280px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}

.year_style {
  margin-right: 10px;
  color: #51627d;
}

.class-name {
  width: calc(100% - 10px) !important;
}

#video-output {
  width: 280px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 280px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.className-style {
  width: calc(100% - 110px);
}

/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}

.form-text-center {
  text-align: center !important;
}

.input {
  width: 150px !important;
}

.tips {
  width: 720px;
  background: #ececec;
  border-radius: 4px;
  padding: 4px;

  p {
    line-height: 22px;
    margin: 0;
    padding: 0;
  }
}
</style>
